export enum DappEnum {
  LIDO = 'LIDO',
  RENZO = 'RENZO',
  AERODROME = 'AERODROME',
  CURVE = 'CURVE',
  BIMA = 'BIMA',
  MORPHO = 'MORPHO',
  FASTLANE = 'FASTLANE',
}
